module.exports = __webpack_public_path__ + "media/images/lb/090-4f62d652599e3233d8ab5d0bcb3fff0f.svg";